import { useEffect, useRef, useState } from 'react';
import { SessionOrigin } from '../api';
import { initializeSession } from './sessionManager';

export const useSession = (accountId: string | undefined, origin: SessionOrigin): string | null => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  // Guard to ensure session is only created once per component lifetime
  const initialized = useRef(false);

  useEffect(() => {
    if (accountId && !initialized.current) {
      initialized.current = true;
      const id = initializeSession(accountId, origin);
      setSessionId(id);
    }
  }, [accountId]);

  return sessionId;
};
